import { render, staticRenderFns } from "./ReusePotentialIndexResult.vue?vue&type=template&id=012389eb&scoped=true"
import script from "./ReusePotentialIndexResult.vue?vue&type=script&lang=js"
export * from "./ReusePotentialIndexResult.vue?vue&type=script&lang=js"
import style0 from "./ReusePotentialIndexResult.vue?vue&type=style&index=0&id=012389eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012389eb",
  null
  
)

export default component.exports